import type { ReactNode } from 'react';
import {
  ErrorBoundary as ReactErrorBoundary,
  type FallbackProps,
} from 'react-error-boundary';
import { ErrorScreen } from '../status-screen';

export interface ErrorBoundaryProps {
  children: ReactNode;
  /** console 記錄的前綴，用來分辨是哪個 app 出錯 */
  logTag: string;
}

/**
 * 包住整個 app 的錯誤邊界：render 期間的例外改顯示整頁錯誤畫面，按「重試」重新渲染。
 */
export function ErrorBoundary({ children, logTag }: ErrorBoundaryProps) {
  return (
    <ReactErrorBoundary
      FallbackComponent={ErrorFallback}
      onError={(error, info) =>
        console.error(
          `[${logTag}] Unhandled error:`,
          error,
          info.componentStack,
        )
      }
    >
      {children}
    </ReactErrorBoundary>
  );
}

function ErrorFallback({ error, resetErrorBoundary }: FallbackProps) {
  return (
    <ErrorScreen
      title="應用發生錯誤"
      message={
        error instanceof Error
          ? error.message
          : '未知錯誤，請重新整理頁面再試一次。'
      }
      onRetry={resetErrorBoundary}
      className="min-h-dvh"
    />
  );
}
